import { Star } from "lucide-react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "@/components/ui/carousel";
import { testimonials } from "@/config/checklisteConfig";

const TestimonialsCarousel = () => {

  return (
    <section className="py-20 sm:py-28 lg:py-32">
      <div className="container max-w-7xl mx-auto px-6 sm:px-8">
        
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Vertraut von <span className="text-accent">hunderten Praxen</span>
          </h2>
          <p className="text-xl sm:text-2xl text-muted-foreground">
            Das sagen unsere Kunden
          </p>
        </div>
        
        {/* Carousel */}
        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full"
        >
          <CarouselContent>
            {testimonials.map((item, index) => {
              const initials = item.author.split(' ').map(n => n[0]).join('');
              return (
                <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                  <div className="border border-white/10 rounded-xl p-8 backdrop-blur-sm h-full flex flex-col">
                    
                    {/* Header: Avatar + Name */}
                    <div className="flex items-center gap-4 mb-4">
                      <Avatar className="w-20 h-20 border-2 border-accent/30">
                        <AvatarImage src={item.image} alt={`${item.author}, ${item.practice} - Kundenbewertung zur Cyberversicherungs-Checkliste`} loading="lazy" />
                        <AvatarFallback className="bg-accent/20 text-accent font-bold text-xl">
                          {initials}
                        </AvatarFallback>
                      </Avatar>
                      <div>
                        <div className="font-bold text-foreground text-lg">{item.author}</div>
                        <div className="text-base text-muted-foreground">{item.practice}</div>
                      </div>
                    </div>
                    
                    {/* Rating */}
                    <div className="flex gap-1 mb-3">
                      {[...Array(item.rating)].map((_, i) => (
                        <Star key={i} className="w-4 h-4 fill-accent text-accent" />
                      ))}
                    </div>
                    
                    {/* Quote */}
                    <p className="text-base sm:text-lg text-muted-foreground leading-relaxed flex-grow">
                      "{item.quote}"
                    </p>
                  </div>
                </CarouselItem>
              );
            })}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex" />
          <CarouselNext className="hidden md:flex" />
        </Carousel>
      </div>
    </section>
  );
};

export default TestimonialsCarousel;
